export enum AISuggestionResultErrorCode {
  ServerError,
  InvalidCaseID,
  SuggestionUsedByUser,
  AIGenerationError,
  InvalidSuggestionID,
  SuggestionFailedContentModeration,
  MfaShouldBeEnabled,
  UserNotEligible,
  FeatureDisabled
}

export enum ConversationItemType {
  Reply = 1,
  ThreadViewEvent,
  AttachmentViewEvent,
  Attachment,
  CallEvent,
  VideoCallEvent,
  VideoVoicemailEvent,
  CalendarEventSuggestion,
  CalendarEventThreadLog,
  PaymentRequestSuggestion,
  PaymentRequestThreadLog
}
